/* ===================== Kit illustrations (build SVG panels inline — no <use> dependency) ===================== */
(function() {
  function buildPanel(cols, rows) {
    var cell = 24, pad = 8, gap = 2;
    var w = cols * cell + pad * 2;
    var h = rows * cell + pad * 2;
    var cells = '';
    for (var r = 0; r < rows; r++) {
      for (var c = 0; c < cols; c++) {
        var x = pad + c * cell;
        var y = pad + r * cell;
        var cw = cell - gap;
        var ch = cell - gap;
        cells += '<rect x="' + x + '" y="' + y + '" width="' + cw + '" height="' + ch + '" rx="2" fill="rgba(46,139,115,0.3)" stroke="rgba(46,139,115,0.5)" stroke-width="1"/>';
        cells += '<line x1="' + (x + cw / 2) + '" y1="' + y + '" x2="' + (x + cw / 2) + '" y2="' + (y + ch) + '" stroke="rgba(0,0,0,0.15)" stroke-width="0.5"/>';
        cells += '<line x1="' + x + '" y1="' + (y + ch / 2) + '" x2="' + (x + cw) + '" y2="' + (y + ch / 2) + '" stroke="rgba(0,0,0,0.15)" stroke-width="0.5"/>';
      }
    }
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
             '<rect x="0" y="0" width="' + w + '" height="' + h + '" rx="5" fill="#1C2B2A"/>' +
             cells +
             '<rect x="3" y="3" width="' + (w - 6) + '" height="2" rx="1" fill="rgba(255,255,255,0.07)"/>' +
           '</svg>';
  }
  document.querySelectorAll('.kit-illus[data-config]').forEach(function(el) {
    try {
      var cfg = JSON.parse(el.dataset.config);
      el.innerHTML = cfg.map(function(p) { return buildPanel(p.cols, p.rows); }).join('');
    } catch (e) { /* leave empty on parse error */ }
  });
})();

/* ===================== NAV: scroll state + hamburger ===================== */
(function() {
  var nav = document.getElementById('nav');
  var onScroll = function() {
    if (window.scrollY > 12) nav.classList.add('scrolled');
    else nav.classList.remove('scrolled');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  var ham = document.getElementById('hamburger');
  var menu = document.getElementById('mobileMenu');
  ham.addEventListener('click', function() {
    var open = menu.classList.toggle('open');
    ham.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
  });
  menu.querySelectorAll('a').forEach(function(a) {
    a.addEventListener('click', function() {
      menu.classList.remove('open');
      ham.setAttribute('aria-expanded', 'false');
    });
  });
})();

/* ===================== Reveal on scroll ===================== */
(function() {
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    els.forEach(function(e) { e.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function(e) { io.observe(e); });
})();

/* ===================== Savings calculator ===================== */
(function() {
  var slider        = document.getElementById('billSlider');
  var billValue     = document.getElementById('billValue');
  var annualSave    = document.getElementById('annualSave');
  var offsetPct     = document.getElementById('offsetPct');
  var paybackMonths = document.getElementById('paybackMonths');
  var stats = ['stat-annual','stat-offset','stat-payback'].map(function(id) { return document.getElementById(id); });
  if (!slider || !billValue || !annualSave || !offsetPct || !paybackMonths) return;

  var cfg          = window.SOLA_CALC || {};
  var KWH_PER_YEAR = cfg.kwhPerYear != null ? cfg.kwhPerYear : 650;
  var UNIT_RATE    = cfg.unitRate    != null ? cfg.unitRate   : 0.245;
  var KIT_PRICE    = cfg.kitPrice    != null ? cfg.kitPrice   : 299;
  var MAX_ANNUAL   = KWH_PER_YEAR * UNIT_RATE;

  function fmtInt(n) { return Math.round(n).toLocaleString('en-GB'); }

  function compute(monthlyBill) {
    var annualBill = monthlyBill * 12;
    var annual = Math.min(MAX_ANNUAL, annualBill);
    var pct    = annualBill > 0 ? (annual / annualBill) * 100 : 0;
    var months = annual > 0 ? Math.ceil(KIT_PRICE / (annual / 12)) : Infinity;
    return { annual: annual, pct: pct, months: months };
  }

  function flash() {
    stats.forEach(function(s) {
      if (!s) return;
      s.classList.remove('tick');
      void s.offsetWidth;
      s.classList.add('tick');
    });
  }

  function update() {
    var v = parseInt(slider.value, 10) || 0;
    billValue.textContent = v;
    var r = compute(v);
    annualSave.textContent    = fmtInt(r.annual);
    offsetPct.textContent     = r.pct >= 99.5 ? 100 : Math.round(r.pct);
    paybackMonths.textContent = isFinite(r.months) ? r.months : 'n/a';
    flash();
  }

  slider.addEventListener('input',  update);
  slider.addEventListener('change', update);
  update();
})();

/* ===================== FAQ accordion ===================== */
(function() {
  document.querySelectorAll('.faq-item').forEach(function(item) {
    var btn = item.querySelector('.faq-q');
    btn.addEventListener('click', function() {
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();


/* ===================== Waitlist modal ===================== */
(function() {
  var modal    = document.getElementById('waitlist-modal');
  var backdrop = modal && modal.querySelector('.wl-modal__backdrop');
  var closeBtn = modal && modal.querySelector('.wl-modal__close');
  var form     = modal && modal.querySelector('#wl-modal-form');
  var wrap     = modal && modal.querySelector('#wl-modal-form-wrap');
  if (!modal) return;

  function openModal() {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var input = modal.querySelector('.wl-modal__input');
    if (input) setTimeout(function() { input.focus(); }, 50);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  // Intercept all #waitlist anchor clicks
  document.addEventListener('click', function(e) {
    var a = e.target.closest('a[href="#waitlist"], a[href="/#waitlist"]');
    if (a) { e.preventDefault(); openModal(); }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (backdrop) backdrop.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email     = (form.querySelector('[name="email"]') || {}).value.trim();
      var firstName = (form.querySelector('[name="first_name"]') || {}).value.trim();
      var lastName  = (form.querySelector('[name="last_name"]') || {}).value.trim();
      var product   = (form.querySelector('[name="preferred_product"]') || {}).value;
      if (!email) return;
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Joining...'; }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  last_name: lastName,
                  properties: { preferred_product: product }
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: 'WCqALH' }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=V3tuv8', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function(r) {
        if (r.ok) {
          wrap.innerHTML = '<p class="wl-modal__success">You\'re on the list. We\'ll be in touch soon.</p>';
          return;
        }
        return r.text().then(function(body) {
          console.error('Klaviyo error', r.status, body);
          throw new Error(r.status);
        });
      }).catch(function(err) {
        if (btn) { btn.disabled = false; btn.textContent = 'Join the waitlist'; }
        var existing = wrap.querySelector('.wl-modal__error');
        if (!existing) {
          wrap.insertAdjacentHTML('beforeend', '<p class="wl-modal__error">Something went wrong. Please try again.</p>');
        }
      });
    });
  }
})();

/* ===================== Waitlist page form ===================== */
(function() {
  var wrap = document.getElementById('sola-waitlist-wrap');
  if (!wrap) return;
  var form = wrap.querySelector('form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var emailEl = form.querySelector('[type="email"]');
    var email = emailEl ? emailEl.value.trim() : '';
    if (!email) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Joining...'; }

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=V3tuv8', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            list_id: 'WCqALH'
          }
        }
      })
    }).then(function(r) {
      if (r.ok) {
        wrap.innerHTML = '<p style="color:#1A6B5A;font-size:15px;margin:0;padding:12px 16px;background:#E0F2EE;border-radius:8px;">You\'re on the list. We\'ll be in touch soon.</p>';
      } else { throw new Error(); }
    }).catch(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Join the waitlist'; }
      var existing = wrap.querySelector('.waitlist-error');
      if (!existing) {
        wrap.insertAdjacentHTML('beforeend', '<p class="waitlist-error" style="color:#991B1B;font-size:14px;margin-top:12px;">Something went wrong. Please try again.</p>');
      }
    });
  });
})();
